export const suggestionVerificationQueryStopLimit = 1000;
export const SEARCH_PHRASE = 'Search phrase';
export const GRAPH_PATTERN = 'Graph pattern';
export const integerTypes = ['integer', 'int', 'bigint'];
export const numericTypes = ['number', 'float', ...integerTypes];
